namespace TabAurous.Purchase {
    export interface OrderForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        GstVat: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.LookupEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: OrderItemsEditor;
        ShipmentId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class OrderForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.Order';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderForm.init)  {
                OrderForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = OrderItemsEditor;

                Q.initFormType(OrderForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'PartyId', w3,
                    'LedgerName', w1,
                    'Address1', w4,
                    'State', w1,
                    'Country', w1,
                    'TermsId', w2,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'CurrencyId', w3,
                    'ExchRate', w5,
                    'GstVat', w1,
                    'UserId', w3,
                    'EmployeeId', w3,
                    'ProductItemImage', w6,
                    'ItemDetails', w7,
                    'ShipmentId', w2,
                    'FinancialYearId', w2,
                    'Pieces', w2,
                    'Weight', w5,
                    'NetWeight', w5,
                    'NetAmount', w5,
                    'CCNetAmount', w5,
                    'Discount', w5,
                    'AdditionalCharges', w5,
                    'GrossAmount', w5,
                    'CCGrossAmount', w5,
                    'Remark', w4,
                    'ShipAddressId', w2,
                    'CompanyId', w2
                ]);
            }
        }
    }
}
